import script from "./RecommendEditDefinedOrder.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendEditDefinedOrder.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendEditDefinedOrder.vue?vue&type=style&index=0&id=d789e45a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d789e45a"]])

export default __exports__